import React from 'react';
import { IStyle, mergeStyleSets } from '@fluentui/react';
import { IParagraphOrHeaderComponentModel } from '../../parser/paragraph-header';

interface IMarkdownHeadingProps {
  componentModel: IParagraphOrHeaderComponentModel;
  hostSectionIsTimed: boolean;
}

const getHeaderClasses = () => {
  const h1: IStyle = {
    lineHeight: '1.65em',
    margin: 0,
    fontSize: '1.5em',
    marginTop: '1.5em',
    marginBottom: '0.5em',
    fontWeight: 600,
  };
  const h2: IStyle = {
    lineHeight: '1.54em',
    margin: 0,
    fontSize: '1.4em',
    marginTop: '1.4em',
    marginBottom: '0.5em',
    fontWeight: 600,
  };
  const h3: IStyle = {
    lineHeight: '1.43em',
    margin: 0,
    fontSize: '1.3em',
    marginTop: '1.3em',
    marginBottom: '0.5em',
    fontWeight: 600,
  };
  const h4: IStyle = {
    lineHeight: '1.32em',
    margin: 0,
    fontSize: '1.2em',
    marginTop: '1.2em',
    marginBottom: '0.5em',
    fontWeight: 600,
  };
  const h5: IStyle = {
    lineHeight: '1.21em',
    margin: 0,
    fontSize: '1.1em',
    marginTop: '1.1em',
    marginBottom: '0.5em',
    fontWeight: 600,
  };
  const h6: IStyle = {
    lineHeight: '1.1em',
    margin: 0,
    fontSize: '1em',
    marginTop: '1em',
    marginBottom: '0.5em',
    fontWeight: 600,
  };

  return mergeStyleSets({ h1, h2, h3, h4, h5, h6 });
}

export const MarkdownHeading: React.FunctionComponent<IMarkdownHeadingProps> = (props) => {
  const { componentModel } = props;
  const level = props.hostSectionIsTimed && componentModel.headerLevel! < 6 ? componentModel.headerLevel! + 1 : componentModel.headerLevel!;
  const headerClasses = getHeaderClasses();

  return (
    <>
      {level === 1 && <h1 className={headerClasses.h1} dangerouslySetInnerHTML={{ __html: componentModel.text }} />}
      {level === 2 && <h2 className={headerClasses.h2} dangerouslySetInnerHTML={{ __html: componentModel.text }} />}
      {level === 3 && <h3 className={headerClasses.h3} dangerouslySetInnerHTML={{ __html: componentModel.text }} />}
      {level === 4 && <h4 className={headerClasses.h4} dangerouslySetInnerHTML={{ __html: componentModel.text }} />}
      {level === 5 && <h5 className={headerClasses.h5} dangerouslySetInnerHTML={{ __html: componentModel.text }} />}
      {level === 6 && <h6 className={headerClasses.h6} dangerouslySetInnerHTML={{ __html: componentModel.text }} />}
    </>
  );
};
